import * as ActionTypes from './ActionTypes';
export function start(auth) {
  return dispatch => {
    dispatch(Object.assign({
      type: ActionTypes.APP_STARTED
    }, auth));
  };
}